import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    isVisible: false,
    id: "",
    place_name: "",
    service_name: "",
    account_name: "",
    number_bill: "",
    record: {},
};
function reducer(state = defaultState, {type, payload }: reduxType) {
    switch (type) {
        case "setUploadPayModal":
            return payload
        default:
            return state;    
    }
}
export default reducer;